import type { PatientApi, TranscriptionConfigQuery } from "@/Modules/Models/Api/User";
import type { UserApi } from "@/Modules/Models/Api/User";
import { get2, patch2 } from "./utils/FunctionalTherapyApi";

export function getCustomerById(customerId: string): Promise<UserApi | undefined> {
  return get2<void, UserApi>(`/v2.0/users/${customerId}`);
}

export function getPatientInfoById(customerId: string): Promise<UserApi | undefined> {
  return get2<void, UserApi>(`/v1.0/users/${customerId}/patient-info`);
}

export function configTranscription(
  customerId: string,
  transcriptionConfig: TranscriptionConfigQuery
): Promise<void> {
  return patch2<TranscriptionConfigQuery, void>(
    `/v2.0/users/${customerId}/transcription`,
    transcriptionConfig
  );
}

export async function getPatientByUser(userId: string): Promise<PatientApi | undefined> {
  const patientApiResponse = await get2<void, PatientApi[]>(`/v1.0/customers?user_uuid=${userId}`);

  return patientApiResponse.shift();
}
